/* eslint-disable import/max-dependencies */
// @flow
import React, { type StatelessFunctionalComponent } from "react";
import { Grid } from "@mui/material";
import SegmentsList from "../../components/SegmentsList";
import ViewList from "../../components/Segments";
import ListModalSetupForm from "../Form/ListModalSetupForm";
import StepControl from "../StepControl";
import { useNotificationError } from "../../hooks";

const SegmentsStep: StatelessFunctionalComponent<{}> = () => {
  useNotificationError("segments");

  return (
    <Grid container sx={{ mt: 3 }}>
      <Grid item container justifyContent="center" alignItems="center">
        <ListModalSetupForm
          name="webPushSegments"
          ListComponent={SegmentsList}
          title="ADD SEGMENTS"
          listName="webPushSegments"
          openOnEmpty
          ViewList={ViewList}
        />
        <Grid item xs={8}>
          <StepControl />
        </Grid>
      </Grid>
    </Grid>
  );
};
export default SegmentsStep;
